// extracted by mini-css-extract-plugin
export default {"clear":"reset_clear_swLbQ","clearfix":"reset_clearfix_B2UUg"};